import { render, staticRenderFns } from "./FactoryCarbonManagement.vue?vue&type=template&id=61507bb2&scoped=true"
import script from "./FactoryCarbonManagement.vue?vue&type=script&lang=js"
export * from "./FactoryCarbonManagement.vue?vue&type=script&lang=js"
import style0 from "./FactoryCarbonManagement.vue?vue&type=style&index=0&id=61507bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61507bb2",
  null
  
)

export default component.exports